<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { Router, Link } from "svelte-routing";
</script>

<footer class="w-full bg-darkblue"><!-- absolute bottom-0  -->
    <div class="container">
        <div class="z-10 md:h-20 flex flex-row md:flex-row flex-wrap">
            <div class="h-full w-full md:w-[50%] flex items-center justify-center md:justify-start">
                <a href="https://www.postfinance.ch/billing-solutions" target="_blank">
                    <img class="h-16 md:pl-6 pt-1" src="/assets/images/postfinance.png" alt="postfinance logo">
                </a>
                <a href="https://swissdigin.gs1.ch" target="_blank">
                    <img class="h-16 pt-1" src="/assets/images/swissdigin-logo.png" alt="swissdigin logo">
                </a>
            </div>
            <div class="w-full text-center md:w-[50%] flex items-center justify-center md:place-content-around mb-2 md:mb-0 underline text-sm text-white">
                <Router>
                    <Link to="publication">{$_("publication.title")}</Link>
                </Router>
            </div>
        </div>
    </div>
</footer>
